// 本地认证态工具：JWT 解析与登录信息存取（不引入新的状态管理）

// 解析 JWT payload，解析失败返回 null
export function getTokenPayload(token) {
  try {
    const part = token.split('.')[1];
    if (!part) return null;
    const json = atob(part.replace(/-/g, '+').replace(/_/g, '/'));
    return JSON.parse(decodeURIComponent(escape(json)));
  } catch (e) {
    return null;
  }
}

// token 存在、可解析且未过期（exp 秒级时间戳）才视为有效
export function isTokenValid(token) {
  if (!token) return false;
  const payload = getTokenPayload(token);
  if (!payload) return false;
  if (payload.exp && payload.exp * 1000 <= Date.now()) return false;
  return true;
}

// 读取本地缓存的用户信息（含 role），解析失败返回空对象
export function getStoredUser() {
  try {
    return JSON.parse(localStorage.getItem('qhy_user') || '{}');
  } catch (e) {
    return {};
  }
}

// 清理登录态
export function clearAuth() {
  localStorage.removeItem('qhy_token');
  localStorage.removeItem('qhy_user');
}

// 当前登录用户是否为只读角色（viewer）：仅能查看，写操作入口应隐藏或禁用（后端另有 403 强制兜底）
export function isViewer() {
  return getStoredUser().role === 'viewer';
}
